import { useState } from 'react';
import EstudianteCursoTab from '../EstudiantesCursos/EstudianteCursoTab';
import CarreraEstudianteTab from '../EstudiantesCursos/CarreraEstudianteTab';
import AlertDialog from '../../Shared/AlertDialog';

const tabsList = [
    { key: 'cursos', label: 'Cursos Asignados' },
    { key: 'carreras', label: 'Carreras' },
];

export default function EstudiantesTabs({ idEstudiante, onClose }) {
    const [active, setActive] = useState('cursos');
    const [isDirty, setIsDirty] = useState(false);
    const [alertDialog, setAlertDialog] = useState({ open: false, title: '', message: '', variant: 'warning' });
    const hasValidContext = Number(idEstudiante || 0) > 0;

    if (!hasValidContext) {
        return (
            <div className="person-tabs-disabled">
                <span>
                    Selecciona o crea un estudiante y pulsa <b>Editar</b> para gestionar sus cursos y carreras.
                </span>
            </div>
        );
    }

    return (
        <div className="person-tabs-wrap">
            <div className="person-tabs-bar">
                {tabsList.map((t) => {
                    const disabledStyles = (isDirty && active !== t.key) ? { opacity: 0.5, cursor: 'not-allowed' } : {};
                    return (
                        <button
                            key={t.key}
                            className={`person-tab ${active === t.key ? 'is-active' : ''}`}
                            style={disabledStyles}
                            onClick={() => {
                                if (isDirty && active !== t.key) {
                                    setAlertDialog({
                                        open: true,
                                        title: 'Cambios sin guardar',
                                        message: 'Tienes cambios sin guardar en la pestaña actual. Por favor guárdalos o cancélalos antes de cambiar.',
                                        variant: 'warning'
                                    });
                                    return;
                                }
                                setActive(t.key);
                            }}
                        >
                            {t.label}
                        </button>
                    );
                })}
            </div>

            <div className="person-tab-panel">
                {active === 'cursos' && <EstudianteCursoTab idEstudiante={idEstudiante} onClose={onClose} onDirtyChange={setIsDirty} />}
                {active === 'carreras' && <CarreraEstudianteTab idEstudiante={idEstudiante} onClose={onClose} onDirtyChange={setIsDirty} />}
            </div>

            {alertDialog.open && (
                <AlertDialog
                    open={alertDialog.open}
                    onClose={() => setAlertDialog(prev => ({ ...prev, open: false }))}
                    title={alertDialog.title}
                    message={alertDialog.message || ""}
                    variant={alertDialog.variant || "warning"}
                />
            )}
        </div>
    );
}
